module.exports = __webpack_public_path__ + "static/flags/NU-3841ad7969219430222883b24850fbe0.gif";